import HttpFactory from '../factory'

class AuthModule extends HttpFactory {
  RESOURCE = `/auth`
  async login(credentials) {
    return await this.call(`POST`, `${this.RESOURCE}/login`, credentials)
  }

  async create(account) {
    return await this.call(`POST`, `${this.RESOURCE}/register`, account)
  }

  async setNuxt(nuxt3ByDefault) {
    return await this.call(`GET`, `/set_nuxt3_by_default?nuxt3_by_default=${nuxt3ByDefault}`)
  }
}

export default AuthModule
